const buildFormData = (
  formData: FormData,
  data: any,
  parentKey?: string,
): void => {
  if (
    data &&
    typeof data === "object" &&
    !(data instanceof Date) &&
    !(data instanceof File) &&
    !(data instanceof Blob)
  ) {
    Object.keys(data).forEach((key) => {
      buildFormData(
        formData,
        data[key],
        parentKey ? `${parentKey}[${key}]` : key,
      );
    });
  } else if (parentKey) {
    if (data === undefined) {
      return;
    }
    let value = data == null ? "" : data;
    if (data instanceof Date) {
      value = data.toISOString();
    }

    formData.append(parentKey, value);
  }
};

export default buildFormData;
